import { managerFactory } from "@/factories/manager";
import { initializeBackendApiClient } from "@/manager/backend-api-client/initializeBackendApiManager";

export const backendApiClientManager = managerFactory.create({
  initializer: initializeBackendApiClient,
});

export type BackendApiClient = ReturnType<(typeof backendApiClientManager)["instance"]>;
